function injectStyle (ssrContext) {
  require("!!../../_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../_vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-47f6035a\",\"scoped\":false,\"hasInlineConfig\":false}!../../_vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./Icon.vue")
}
var Component = require("!../../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./Icon.vue"),
  /* template */
  require("!!../../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-47f6035a\",\"hasScoped\":false}!../../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./Icon.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-awesome@2.3.7@vue-awesome/components/Icon.vue
// module id = 0
// module chunks = 43